import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { EditScoutingOverviewModal } from './EditScoutingOverviewModal'
import DeleteModal from "../../shared/DeleteModal";
import moment from 'moment';
// firebase
import { db } from "../../../firebase";

// styles
import styles from "../detail.module.scss";

// icons
import { FaSearch } from "react-icons/fa";
import {
    MdModeEdit,
    MdRemoveRedEye,
    MdRestoreFromTrash,
} from "react-icons/md";
import log_activity from "../../activity/logger";

export function ScoutingOverview({ playerID, playerName }) {
    const [scoutingOverview, setScoutingOverview] = useState(null);
    const [selectedEditScoutingOverview, setSelectedEditScoutingOverview] = useState(false);
    const [selectedDeleteScoutingOverview, setSelectedDeleteScoutingOverview] = useState(false);
  
    const getScoutingOverview = async () => {
      try {
        const response = await db.collection("scouting-overview").where("playerProfile", "==", playerID).get();
        response.docs[0] && setScoutingOverview({ ...response.docs[0].data(), id: response.docs[0].id });
      } catch (error) {
        console.log(error, "error");
      }
    }
  
    const handleDelete = () => {
      db.collection("scouting-overview")
        .where("playerProfile", "==", playerID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.docs[0].ref.delete()
            .then(() => {
              toast.error("Scouting Overview Deleted Successfully", {
                theme: "colored",
              });
              log_activity(playerName, "Scouting Overview Was Deleted")
              setScoutingOverview(null);
            })
        })
        .catch((error) => {
          console.error(error)
          toast.error("Error Deleting Scouting Overview", {
            theme: "colored",
          });
        });
    };
  
    useEffect(() => {
      getScoutingOverview();
    }, [playerID]); // Include playerID in the dependency array
  
    return (
      <>
        <DeleteModal
          handleClose={() => {
            setSelectedDeleteScoutingOverview(false);
            getScoutingOverview();
          }}
          show={selectedDeleteScoutingOverview}
          handleConfirm={() => {
            handleDelete();
          }}
        />
        {/* Edit ScoutingOverview Section */}
        {selectedEditScoutingOverview && (
          <EditScoutingOverviewModal
            show={selectedEditScoutingOverview}
            handleClose={() => {
              setSelectedEditScoutingOverview(false);
              getScoutingOverview();
            }}
            scoutingOverviewData={scoutingOverview}
          />
        )}
        <div className={styles.singleSection}>
          <h2>Scouting Overview</h2>
          {scoutingOverview ? (
            <div>
              {/*
              <MdRemoveRedEye />
              */}
              <MdModeEdit
                onClick={() => setSelectedEditScoutingOverview(true)}
                style={{
                  color: "green",
                  marginLeft: "10px",
                }}
              />
              <MdRestoreFromTrash
                onClick={() => setSelectedDeleteScoutingOverview(true)}
                style={{
                  color: "red",
                  marginLeft: "10px",
                }}
              />
            </div>
          ) : (
            <div className={styles.scoutingOverviewNotAvailable}>
              <a href="/scouting-overview/create">Scouting Overview not available, please create one using this link</a>
            </div>
          )}
        </div>
      </>
    );
  };